import React from 'react'
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import Stack from 'react-bootstrap/Stack'
import logo from '../images/svgs/brand-logo-white.svg'
import icon from '../images/icon.png'
import CountrySelector from './country-selector'

export default function Naviagtion({ style }) {
    return (
        <Navbar sticky='top' expand={false} className='p-0 bg-black' style={style}>
            <Container fluid className='p-0'>
                <Container>
                    <div className='position-relative d-flex align-items-center justify-content-between border-bottom border-dark'>
                        <Navbar.Brand className='p-0 m-0'>
                            <a href='https://enginedj.com/' target='_blank' rel='noreferrer' className='d-block' style={{ paddingTop: 28, paddingBottom: 28 }}>
                                <img src={icon} alt='' className='d-sm-none' height='28' />
                                <img src={logo} alt='' className='d-none d-sm-inline-block' />
                                <span 
                                    style={{fontSize: 18, paddingLeft: 16, marginLeft: 16}} 
                                    className='text-light border-start border-dark'
                                >
                                    Store
                                </span>
                            </a>
                        </Navbar.Brand>
                        
                        <Stack direction='horizontal' className='align-items-center' gap={4}>
                            <CountrySelector style={{ paddingTop: 28, paddingBottom: 28 }} />
                        </Stack>
                    </div>
                </Container>
            </Container>
        </Navbar>
    )
}
